// extracted by mini-css-extract-plugin
module.exports = {"root":"EmbeddedWebpage_root","iframe":"EmbeddedWebpage_iframe","blockerOverlay":"EmbeddedWebpage_blockerOverlay"};